import React from 'react';
import { Edit } from 'react-admin';
import { getTransform } from '../rateSettingsTransform';
import RateSettingsForm from '../shared/rate-settings-form/RateSettingsForm';

const StateLocationTypeRateSettingEdit = () => (
  <Edit
    mutationMode="pessimistic"
    transform={getTransform(['state_id', 'location_type_id'], 'state_location_type_rate_setting')}
  >
    <RateSettingsForm settingsField="state_location_type_rate_setting" />
  </Edit>
);

export default StateLocationTypeRateSettingEdit;
